"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var Row_1 = require("../Row");
var ScreenClassResolver_1 = __importDefault(require("../../context/ScreenClassResolver"));
var config_1 = require("../../config");
var style_1 = __importDefault(require("./style"));
var Col = function (_a) {
    var xs = _a.xs, sm = _a.sm, md = _a.md, lg = _a.lg, xl = _a.xl, 
    // xxl,
    offset = _a.offset, pull = _a.pull, push = _a.push, _b = _a.component, component = _b === void 0 ? 'div' : _b, children = _a.children, width = _a.width, rest = __rest(_a, ["xs", "sm", "md", "lg", "xl", "offset", "pull", "push", "component", "children", "width"]);
    return ((0, jsx_runtime_1.jsx)(ScreenClassResolver_1.default, { children: function (screenClass) { return ((0, jsx_runtime_1.jsx)(Row_1.GutterWidthContext.Consumer, { children: function (gutterWidth) {
                return (0, react_1.jsx)(component, __assign({ css: (0, style_1.default)({
                        forceWidth: width,
                        width: {
                            xs: xs,
                            sm: sm,
                            md: md,
                            lg: lg,
                            xl: xl,
                            // xxl,
                        },
                        offset: offset,
                        pull: pull,
                        push: push,
                        screenClass: screenClass,
                        gutterWidth: gutterWidth,
                        gridColumns: (0, config_1.getConfiguration)().gridColumns,
                    }) }, rest), children);
            } })); } }));
};
exports.default = Col;
//# sourceMappingURL=index.js.map